/**
 * DataContext
 *
 * Wraps useFirebaseData so any component can call useData() instead of
 * prop-drilling the Firebase hook through the tree.
 */
import { createContext, useContext } from 'react';
import { useFirebaseData } from './useFirebaseData';

const DataContext = createContext(null);

export function DataProvider({ children }) {
  const data = useFirebaseData();
  return <DataContext.Provider value={data}>{children}</DataContext.Provider>;
}

export function useData() {
  return useContext(DataContext);
}
